import { EventEmitter, Injectable, Output } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ClientSignatureRequestModel } from 'src/app/core/models/members/client/client-signature-request.model';
import { SignatureRequestModalComponent } from './signature-request-modal/signature-request-modal.component';
import { Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SignatureModalService {

  @Output() modelChanged = new EventEmitter<any>();

  constructor(private modalService: NgbModal) { }

  openModal(clientSignatureRequest: ClientSignatureRequestModel, name: string) {
    var model: any;
    var modalRef!: NgbModalRef;
    model = clientSignatureRequest;
    modalRef = this.modalService.open(SignatureRequestModalComponent, { size: 'lg', centered: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.model = model;
    modalRef.componentInstance.clientName = name;

    var sub: Subscription = modalRef.closed.subscribe(() => {
      if (modalRef.componentInstance.emailSent) {
        this.modelChanged.emit(modalRef.componentInstance.model);
      }else{
        this.modelChanged.emit(undefined);
      }
      sub.unsubscribe();
    })
    
  }
}
